import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const ORIGIN = 'https://jpeakeconsulting.co.uk';

export default function SEO({ title, description }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const lang = (i18n.language || 'en').slice(0, 2);
  const fullTitle = title ? `${title} · J Peake Consulting` : 'J Peake Consulting · Senior Commercial Leadership for Education';
  const path = location.pathname || '/';

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:locale" content={lang === 'en' ? 'en_GB' : lang === 'fr' ? 'fr_FR' : 'de_DE'} />
      <link rel="alternate" hrefLang="en" href={`${ORIGIN}${path}`} />
      <link rel="alternate" hrefLang="fr" href={`${ORIGIN}${path}?lang=fr`} />
      <link rel="alternate" hrefLang="de" href={`${ORIGIN}${path}?lang=de`} />
      <link rel="alternate" hrefLang="x-default" href={`${ORIGIN}${path}`} />
    </Helmet>
  );
}
